// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const config = {
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
      region: "us-east-1",
      defaultAuthMode: "apiKey",
      apiKey: process.env.REACT_APP_APPSYNC_APIKEY,
    },
  },
};

export default config;
